
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.266 10.957a2.89 2.89 0 11-4.086 4.086 2.89 2.89 0 014.086-4.086M20.82 5.18a2.89 2.89 0 11-4.085 4.086A2.89 2.89 0 0120.82 5.18M20.82 16.734a2.89 2.89 0 11-4.085 4.086 2.89 2.89 0 014.085-4.086M9.793 11.71l6.414-3.206M9.793 14.29l6.414 3.206"}})])
          )
        }
      }
    